var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Game"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Game"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Game_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Game-2",
    opacity: 0.4,
    d: "M14.9738 6.87265V7.07095C14.4422 7.06051 13.9107 7.06051 13.3791 7.06051V6.88309C13.3791 6.16296 12.7731 5.57851 12.0502 5.57851H10.9977C9.79635 5.57851 8.81827 4.61834 8.81827 3.44943C8.81827 3.02153 9.17973 2.66669 9.61562 2.66669C10.0621 2.66669 10.413 3.02153 10.413 3.44943C10.413 3.76253 10.6788 4.01301 10.9977 4.01301H12.0502C13.6555 4.02345 14.9632 5.30716 14.9738 6.87265Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3792 7.06073C13.9108 7.06073 14.4424 7.06073 14.9739 7.07117C15.9839 7.07117 16.9939 7.09204 18.0145 7.10248C21.7036 7.10248 24.3933 9.73251 24.3933 13.3645V18.0296C24.3933 21.6616 21.7036 24.2916 18.0145 24.2916C16.5367 24.3229 15.059 24.3334 13.5706 24.3334C12.0822 24.3334 10.5832 24.3229 9.10543 24.2916C5.41635 24.2916 2.72662 21.6616 2.72662 18.0296V13.3645C2.72662 9.73251 5.41635 7.10248 9.11606 7.10248C10.5088 7.0816 11.9334 7.06073 13.3792 7.06073ZM10.4024 13.0305C9.95593 13.0305 9.6051 13.3853 9.6051 13.8132V14.9091H8.47818C8.04229 14.9091 7.68083 15.2639 7.68083 15.6918C7.68083 16.1302 8.04229 16.4746 8.47818 16.4746H9.6051V17.5809C9.6051 18.0088 9.95593 18.3636 10.4024 18.3636C10.8383 18.3636 11.1998 18.0088 11.1998 17.5809V16.4746H12.3161C12.752 16.4746 13.1134 16.1302 13.1134 15.6918C13.1134 15.2639 12.752 14.9091 12.3161 14.9091H11.1998V13.8132C11.1998 13.3853 10.8383 13.0305 10.4024 13.0305ZM18.7587 16.7355H18.6524C18.2058 16.7355 17.855 17.0903 17.855 17.5182C17.855 17.9566 18.2058 18.301 18.6524 18.301H18.7587C19.1946 18.301 19.556 17.9566 19.556 17.5182C19.556 17.0903 19.1946 16.7355 18.7587 16.7355ZM16.9407 13.1453H16.8344C16.3879 13.1453 16.0371 13.5001 16.0371 13.928C16.0371 14.3664 16.3879 14.7108 16.8344 14.7108H16.9407C17.3766 14.7108 17.7381 14.3664 17.7381 13.928C17.7381 13.5001 17.3766 13.1453 16.9407 13.1453Z",
    fill: "#D9D9D9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/Game.ec8b11091727543ddb4bec5501fadc50.svg";
export { ForwardRef as ReactComponent };